import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-white px-5 py-16 sm:py-24" data-id="element-95" data-mp="26k9wuh2e19bf">
      <div className="mx-auto max-w-5xl" data-id="element-96" data-mp="22lkcg4ixmria">
        <SectionHeading eyebrow="From improvisation to a structured practice" title={<>
              Before vs. <em className="text-brand-700" data-id="element-98" data-mp="2uc6yxgg1cmzc">with</em> the 7D Protocol™
            </>} data-id="element-97" data-mp="22iockanixsr7" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-99" data-mp="2q9u1rgfctxe6">
          <div className="rounded-3xl bg-[#fbeeee] p-6 ring-1 ring-[#f1d3d1] sm:p-8" data-id="element-100" data-mp="2qcg8jduf88vc">
            <div className="flex items-center gap-3" data-id="element-101" data-mp="2lazb5sb5b4ji">
              <span className="grid h-10 w-10 place-items-center rounded-full bg-urgent text-white" data-id="element-102" data-mp="1evq1jsi6bd0o">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-103" data-mp="19vu5qgjmqrw7" />
              </span>
              <h3 className="text-xl font-extrabold uppercase tracking-wide text-urgent" data-id="element-104" data-mp="175492a0wf67c">Before</h3>
            </div>
            <ul className="mt-6 space-y-3.5" data-id="element-105" data-mp="1c35swx65f9jv">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-snug text-ink" data-id="element-106" data-mp="y3mmc8szk69o">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-urgent" strokeWidth={2.5} aria-hidden="true" data-id="element-107" data-mp="132ptbysj0mka" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-brand-800 p-6 sm:p-8" data-id="element-108" data-mp="t6d0f34t2cql">
            <div className="flex items-center gap-3" data-id="element-109" data-mp="feg74vrehwsm">
              <span className="grid h-10 w-10 place-items-center rounded-full bg-cta text-white" data-id="element-110" data-mp="fg13mqx9zpt4">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-111" data-mp="jg1hoaggpyzn" />
              </span>
              <h3 className="text-xl font-extrabold uppercase leading-tight tracking-wide text-white" data-id="element-112" data-mp="5i3iicapq94q">
                After · with the 7D Protocol™
              </h3>
            </div>
            <ul className="mt-6 space-y-3.5" data-id="element-113" data-mp="2c5u284z146dl">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-snug text-white" data-id="element-114" data-mp="27cr9u05zn2yz">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#5fe08f]" strokeWidth={3} aria-hidden="true" data-id="element-115" data-mp="23ch0qemwfwfw" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <CtaButton label="I want a clear path to get started" className="mt-12" data-id="element-116" data-mp="2v10x76iunys8" />
      </div>
    </section>;
}